import api from '../api/externalOfferApi';
import {actions as notificationActions} from './notificationActions';

export const types = {
  GET_EXTERNAL_OFFER_LIST: 'GET_EXTERNAL_OFFER_LIST',
  GET_EXTERNAL_OFFER_LIST_SUCCESS: 'GET_EXTERNAL_OFFER_LIST_SUCCESS',
  GET_EXTERNAL_OFFER_LIST_FAILURE: 'GET_EXTERNAL_OFFER_LIST_FAILURE',
  CREATE_EXTERNAL_OFFER_SUBMIT: 'CREATE_EXTERNAL_OFFER_SUBMIT',
  CREATE_EXTERNAL_OFFER_SUCCESS: 'CREATE_EXTERNAL_OFFER_SUCCESS',
  CREATE_EXTERNAL_OFFER_FAILURE: 'CREATE_EXTERNAL_OFFER_FAILURE',
  UPDATE_BIKE_TYPE_SUBMIT: 'UPDATE_BIKE_TYPE_SUBMIT',
  UPDATE_BIKE_TYPE_SUCCESS: 'UPDATE_BIKE_TYPE_SUCCESS',
  UPDATE_BIKE_TYPE_FAILURE: 'UPDATE_BIKE_TYPE_FAILURE',
  DELETE_EXTERNAL_OFFER_SUBMIT: 'DELETE_EXTERNAL_OFFER_SUBMIT',
  DELETE_EXTERNAL_OFFER_SUCCESS: 'DELETE_EXTERNAL_OFFER_SUCCESS',
  DELETE_EXTERNAL_OFFER_FAILURE: 'DELETE_EXTERNAL_OFFER_FAILURE',
};

export const actions = {

  loadExternalOffers: (pageNumber, pageSize, sortBy) => (dispatch) => {
    dispatch({type: types.GET_EXTERNAL_OFFER_LIST, pageSize, sortBy, pageNumber});
    return api.getExternalOfferList(pageNumber, pageSize, sortBy).then(res => {
      if (res.ok) {
        dispatch({type: types.GET_EXTERNAL_OFFER_LIST_SUCCESS, result: res.data || {}});
      }
    });
  },
  loadNextExternalOffers: (pageNumber) => (dispatch, getState) => {
    const sortBy = getState().externalOffer.pagedData.sortedBy;
    const pageSize = getState().externalOffer.pagedData.paging.pageSize;
    dispatch({type: types.GET_EXTERNAL_OFFER_LIST, pageSize, sortBy, pageNumber});
    return api.getExternalOfferList(pageNumber, pageSize, sortBy ? sortBy : [],).then(res => {
      if (res.ok) {
        dispatch({type: types.GET_EXTERNAL_OFFER_LIST_SUCCESS, result: res.data || {}});
      }
    });
  },

  create: data => (dispatch) => {
    dispatch({type: types.CREATE_EXTERNAL_OFFER_SUBMIT});

    return api.create(data).then(res => {
      if (res.ok) {
        dispatch({type: types.CREATE_EXTERNAL_OFFER_SUCCESS});
        dispatch(notificationActions.showSuccess('Utworzono nową ofertę'));
        return true;
      } else {
        dispatch({type: types.CREATE_EXTERNAL_OFFER_FAILURE});
        dispatch(notificationActions.showError('Wystąpił problem podczas tworzenia nowej oferty'));
        return false;
      }
    });
  },

  update: (id, data) => (dispatch) => {
    return api.update(id, data).then(res => {
      if (res.ok) {
        dispatch(notificationActions.showSuccess('Oferta został zaktualizowany'));
        return true;
      } else {
        dispatch(notificationActions.showError('Wystąpił problem podczas aktualizacji'));
        return false;
      }
    });
  },

  delete: id => (dispatch) => {
    return api.delete(id).then(res => {
      if (res.ok) {
        dispatch(notificationActions.showSuccess('Oferta została usunięta'));
        return true
      } else {
        dispatch(notificationActions.showError('Wystąpił problem podczas usuwania oferty'));
        return false
      }
    });
  },
};
